import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";

/**
 * Scrolls to the element matching `location.hash` whenever the route changes.
 * React Router does not auto-scroll to fragments by default; this restores the
 * native browser behavior so links like `/landing#pricing` land on the section.
 *
 * Smooth scrolling and the offset for the fixed header are handled in CSS via
 * `html { scroll-behavior: smooth; scroll-padding-top: 5rem; }` (see index.css).
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    // Wait one frame so the target route has mounted its DOM.
    const raf = requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ block: "start" });
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
}
